(function(){
  var DEBUG = true; // set to false to silence logs
  function log(){ if(DEBUG && window.console) console.log.apply(console, arguments); }
  function $(sel, root){ return (root||document).querySelector(sel); }
  function $all(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }
  function ready(fn){ if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fn);} else { fn(); } }

  // Denim’s inner list selector(s)
  var LIST_SELECTOR = '.product__media-list, [data-product-media-list], .media-gallery__list';

  function attach(anchor){
    if (anchor.dataset.vmgBound === '1') return;
    anchor.dataset.vmgBound = '1';

    var key   = anchor.id.replace('vmg-anchor-','');
    var data  = $('#vmg-data-' + key);
    var map   = {};
    try { map = JSON.parse(data ? data.textContent : '{}'); }
    catch(e){ log('VMG JSON parse error', e); return; }

    var wrapper = anchor.closest('.product__media-wrapper');
    if(!wrapper){ log('VMG: wrapper not found'); return; }

    function findList(){ return wrapper.querySelector(LIST_SELECTOR); }
    var list = findList();
    if(!list){
      // If the theme builds the list after load, wait for it.
      var mo = new MutationObserver(function(){
        list = findList();
        if(list){ mo.disconnect(); init(); }
      });
      mo.observe(wrapper, {childList:true, subtree:true});
      return;
    }
    init();

    function cacheOriginal(){
      if(!list.dataset.vmgOriginal) list.dataset.vmgOriginal = list.innerHTML;
    }

    function build(items){
      return items.map(function(it){
        var src = it && it.src ? it.src : '';
        var alt = it && it.alt ? it.alt.replace(/"/g,'&quot;') : '';
        return (
          '<div class="product__media-item product__media">' +
            '<div class="media">' +
              '<img src="'+src+'" alt="'+alt+'" loading="lazy" decoding="async">' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    function currentVariantId(){
      var scope = wrapper.parentElement || document;
      var idInput = $('form[action*="/cart/add"] input[name="id"]', scope);
      return (idInput && idInput.value) ? String(idInput.value)
             : String(anchor.getAttribute('data-initial-variant-id') || '');
    }

    function update(){
      var vid   = currentVariantId();
      var items = map[vid] || [];
      log('VMG → variant', vid, 'items:', items.length);

      if(items.length){
        cacheOriginal();
        list.innerHTML = build(items);      // replace items, keep the list element
      } else if(list.dataset.vmgOriginal){
        list.innerHTML = list.dataset.vmgOriginal; // restore theme gallery
      }
    }

    function init(){
      log('VMG init for product', key);
      update();
      document.addEventListener('variant:change', update);
      var scope = wrapper.parentElement || document;
      var form  = $('form[action*="/cart/add"]', scope);
      if(form) form.addEventListener('change', function(){ setTimeout(update, 0); });
    }
  }

  ready(function(){ $all('[id^="vmg-anchor-"]').forEach(attach); });
})();
